"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.ModalFooter = exports.ModalClose = exports.ModalBody = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  background-color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  float: right;\n  margin-top: 20px;\n  margin-right: 20px;\n  font-size: 28px;\n  font-weight: 600;\n  transition: ", ";\n  cursor: pointer;\n  color: ", ";\n  z-index: 1002;\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      bottom: 5px;\n      left: 5px;\n      right: 5px;\n      max-width: 100vw;\n      position: fixed;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n      max-width: ", ";\n      margin: 0;\n      height: 100vh;\n      position: fixed;\n      top: 5px;\n      left: 5px;\n      overflow: auto;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n      max-width: ", ";\n      margin: 0;\n      height: 100vh;\n      position: fixed;\n      top: 5px;\n      right: 5px;\n      overflow: auto;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      width: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n  z-index: 1001;\n  ", "\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  ", "\n  \n  ", "\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      display: flex;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: none; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 1000; /* Sit on top */\n  padding-top: 50px; /* Location of the box */\n  padding-bottom: 50px; /* Space at the bottom */\n  left: 0;\n  top: 0;\n  width: 100%; /* Full width */\n  height: 100%; /* Full height */\n  overflow: auto; /* Enable scroll if needed */\n  background-color: ", "; /* Black w/ opacity */\n\n  &::-webkit-scrollbar {\n    width: 10px;\n    display: block;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: ", ";\n    display: block;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: 20px;\n    display: block;\n    border: 3px solid ", ";\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalOverlay = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-modal-overlay"
})(_templateObject(), function (props) {
  return (0, _polished.transparentize)(.4, props.overlayColor);
}, function (props) {
  return props.bgColor ? props.bgColor : props.theme.PrimaryFade;
}, function (props) {
  return (0, _polished.transparentize)(0.2, props.theme.PrimaryFontColor);
}, function (props) {
  return props.bgColor ? props.bgColor : props.theme.PrimaryFade;
}, function (props) {
  return props.open && (0, _styledComponents.css)(_templateObject2());
});
var ModalBodyWrapper = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-modal-body"
})(_templateObject3(), function (props) {
  return props.width && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return props.width;
  });
}, function (props) {
  return props.theme.SecondaryRadius;
}, function (props) {
  return props.bgColor ? props.bgColor : props.theme.PrimaryFade;
}, function (props) {
  return props.theme.PrimaryFontColor;
}, function (props) {
  return props.right && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return props.width;
  });
}, function (props) {
  return props.left && (0, _styledComponents.css)(_templateObject6(), function (props) {
    return props.width;
  });
}, function (props) {
  return props.bottom && (0, _styledComponents.css)(_templateObject7());
});

var ModalBody = function ModalBody(props) {
  return /*#__PURE__*/_react["default"].createElement(ModalBodyWrapper, _extends({}, props, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }), props.children);
};

exports.ModalBody = ModalBody;
var ModalClose = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-modal-close"
})(_templateObject8(), function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return (0, _polished.transparentize)(0.6, props.theme.PrimaryFontColor);
}, function (props) {
  return (0, _polished.darken)(0.4, props.theme.PrimaryFontColor);
});
exports.ModalClose = ModalClose;
var ModalFooter = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-modal-footer"
})(_templateObject9(), function (props) {
  return (0, _polished.transparentize)(0.9, props.footercolor ? props.footercolor : props.theme.PrimaryGreyMid);
});
exports.ModalFooter = ModalFooter;

var Modal = function Modal(props) {
  (0, _react.useEffect)(function () {
    if (props.open === true) {
      document.querySelector('body').style.overflow = 'hidden';
    } else {
      document.querySelector('body').style.overflow = 'auto';
    }
  });
  return /*#__PURE__*/_react["default"].createElement(ModalOverlay, _extends({}, props, {
    onClick: props.outerclick ? props.onClose : function () {},
    overlayColor: props.overlayColor,
    overlayOpacity: props.overlayOpacity
  }), props.children);
};

exports.Modal = Modal;
Modal.defaultProps = {
  open: false,
  overlayColor: "#000",
  overlayOpacity: 0.4,
  width: "90vw",
  center: true
};
Modal.propTypes = {
  open: _propTypes["default"].bool,
  width: _propTypes["default"].string,
  overlayColor: _propTypes["default"].string,
  overlayOpacity: _propTypes["default"].number,
  bgColor: _propTypes["default"].string,
  onClose: _propTypes["default"].any,
  bottom: _propTypes["default"].bool,
  left: _propTypes["default"].bool,
  right: _propTypes["default"].bool,
  center: _propTypes["default"].bool,
  footercolor: _propTypes["default"].string
};